import { render, staticRenderFns } from "./themesDetail.vue?vue&type=template&id=6012e4ba&scoped=true&"
import script from "./themesDetail.vue?vue&type=script&lang=js&"
export * from "./themesDetail.vue?vue&type=script&lang=js&"
import style0 from "./themesDetail.scss?vue&type=style&index=0&id=6012e4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012e4ba",
  null
  
)

export default component.exports